// extracted by mini-css-extract-plugin
module.exports = {"manageWrapper":"manage_manageWrapper__122Rn"};